import sha256 from 'crypto-js/sha256';
import { enc } from 'crypto-js/core';

const FEATURE_FLAG_SUFFIX = 'Flag';

// All possible feature flags
// NOTE: Do not remove FEATURE_FLAG even if empty/unused. This simplifies adding feature flags in the future.
export enum FEATURE_FLAG {
  CHAT_MESSAGE = 'chatMessageFlag',
  UMG = 'umgFlag',
  CSEA_REASON = 'cseaReasonFlag',
}

// Feature flags that are enabled on a per e-mail address basis.
// [!] We can remove this once we have e-mail verification at the first step in the form.
type EMAIL_SPECIFIC_FEATURE_FLAGS_TYPE = {
  [hash: string]: FEATURE_FLAG[];
};

export const EMAIL_SPECIFIC_FEATURE_FLAGS: EMAIL_SPECIFIC_FEATURE_FLAGS_TYPE = {
  '917422a4642d652c8f4da98ecd87d7a1dec0c61cd23540bf6afc111eda2624e9': [FEATURE_FLAG.UMG],
};

export function featureFlagsFromUrl(search?: string) {
  const derivedSearch = search || (window && window.location ? window.location.search : '');
  const queryParams = new URLSearchParams(derivedSearch);
  return new Set([...queryParams.keys()].filter(queryParam => queryParam.endsWith(FEATURE_FLAG_SUFFIX)));
}

export const hasFeatureFlag = (enabledFeatureFlags: Set<String>) => (flagName: FEATURE_FLAG) =>
  enabledFeatureFlags.has(flagName);

export const getFeatureFlagsForEmailAddress = (
  emailSpecificUserFlags: EMAIL_SPECIFIC_FEATURE_FLAGS_TYPE,
  emailAddress: string,
) => {
  const hash = sha256(emailAddress).toString(enc.Hex);

  if (!(hash in emailSpecificUserFlags)) {
    return [];
  }

  return emailSpecificUserFlags[hash];
};
